var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-layout"},[_c('m-head'),_c('div',{staticClass:"content"},[_vm._t("default")],2),(!_vm.isContact)?_c('m-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }